import { render, staticRenderFns } from "./FixedPriceProjectList.vue?vue&type=template&id=25dbf4d7&"
import script from "./FixedPriceProjectList.vue?vue&type=script&lang=js&"
export * from "./FixedPriceProjectList.vue?vue&type=script&lang=js&"
import style0 from "./FixedPriceProjectList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25dbf4d7')) {
      api.createRecord('25dbf4d7', component.options)
    } else {
      api.reload('25dbf4d7', component.options)
    }
    module.hot.accept("./FixedPriceProjectList.vue?vue&type=template&id=25dbf4d7&", function () {
      api.rerender('25dbf4d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/invoices/invoiceRendererV2/FixedPriceProjectList.vue"
export default component.exports